'use strict';

/* global angular */

require('./analytics');
require('./technicalkpis');
require('./auth');
// require('./debug');
require('./filters');
require('./identity');
require('./intercom');
require('./ingestor');
require('./utils');
require('./raven');

angular.module('common', [
  'common.analytics',
  'common.auth',
  // 'common.debug',
  'common.filters',
  'common.intercom',
  'common.utils',
  'common.technicalkpis',
  'common.ingestor',
  'common.raven'
]);



// WEBPACK FOOTER //
// ./src/common/index.js